import type { AX1SignalTone } from '@/components/ui/SignalPulse';

export type AvatarStatus = 'online' | 'away' | 'busy' | 'dnd' | 'offline';

export const AVATAR_STATUS_LABEL: Record<AvatarStatus, string> = {
  online: 'Online',
  away: 'Away',
  busy: 'Busy',
  dnd: 'Do not disturb',
  offline: 'Offline',
};

export const AVATAR_STATUS_TONE: Record<AvatarStatus, AX1SignalTone> = {
  online: 'success',
  away: 'warning',
  busy: 'critical',
  dnd: 'critical',
  offline: 'neutral',
};

// Literal token classes keep dropdown dots aligned with the avatar indicator
// and included in the production Tailwind build.
export const AVATAR_STATUS_SOLID_CLASS: Record<AvatarStatus, string> = {
  online: 'bg-status-success',
  away: 'bg-status-warning',
  busy: 'bg-status-critical',
  dnd: 'bg-status-critical',
  offline: 'bg-status-neutral',
};

export const AVATAR_STATUS_FOREGROUND_CLASS: Record<AvatarStatus, string> = {
  online: 'text-status-success-foreground',
  away: 'text-status-warning-foreground',
  busy: 'text-status-critical-foreground',
  dnd: 'text-status-critical-foreground',
  offline: 'text-text-muted',
};
